import Image from 'next/image';
import Link from 'next/link';

/**
 * `dRepHandle` is a minted asset name resolved by the backend, never a
 * self-declared `dRepName`, so `/${dRepHandle}` is a real profile URL. The
 * caller drops any record without one rather than linking to `/`.
 */
export default function LandingPageDrepCard({
  name,
  dRepHandle,
  votingPower,
  profilePhoto,
  coverPhoto,
}: {
  name: string;
  dRepHandle: string;
  votingPower: number | string;
  profilePhoto: string;
  coverPhoto: string;
}) {
  return (
    // Was a <div onClick={router.push}>. The homepage's six featured DReps
    // emitted no <a href> at all, so the only internal links a crawler could
    // follow from the landing page were the navbar's.
    <Link
      href={`/${dRepHandle}`}
      aria-label={`${name} — DRep profile`}
      className="cursor-pointer overflow-clip border-[1px] border-l-[0.5px] border-r-[0.5px] border-[#282B30] p-2"
    >
      <div className="w-[268px]">
        <div className="relative">
          <div className="relative h-[90px] w-full grayscale">
            <Image
              src={coverPhoto}
              alt=""
              fill
              sizes="268px"
              className="object-cover object-center"
            />
          </div>
          <div className="absolute bottom-[-30px] left-1/2 translate-x-[-50%]">
            {/* Not next/image: the avatar URL comes from the DRep's own
                metadata document, so it can be an arbitrary host or a base64
                data URI, neither of which the optimizer accepts. Same
                treatment as `components/seo/entityCard.tsx`. */}
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={profilePhoto}
              alt=""
              width={65}
              height={65}
              loading="lazy"
              // The host is chosen by the DRep operator, so don't hand it the
              // visitor's referring URL.
              referrerPolicy="no-referrer"
              className="h-[64.8px] w-[64.8px] rounded-full object-cover"
            />
          </div>
          <div />
        </div>
        <div className="px-9 pb-6 pt-12 text-center">
          <p className="body16 max-w-64 truncate text-ellipsis font-semibold">
            {name}
          </p>
          <p className="max-w-64 truncate text-ellipsis text-gray-400">
            @{dRepHandle}
          </p>
          <p className="label12 font-medium text-gray-400">
            Voting Power : &nbsp;
            <span className="body20 font-bold text-white">₳ {votingPower}</span>
          </p>
        </div>
      </div>
    </Link>
  );
}
